import cn from "classnames"
import Logo from "components/Header/Logo"
import { Phone, Send } from "feather-icons-react"
import dynamic from "next/dynamic"
import Link from "next/link"
import { useEffect, useState } from "react"
import nl2br from "utils/nl2br"
import LinkButton from "../ui/LinkButton"
import styles from "./Footer.module.scss"

const Footer = ({
  pageId,
  footerNav = { items: [] },
  footerLinks = { items: [] },
  locations,
  socialMediaLinks,
  company = {},
}) => {
  const [filteredFooterLinks, setFilteredFooterLinks] = useState(null)

  useEffect(() => {
    if (pageId && footerLinks && footerLinks.items?.length > 0) {
      const links = footerLinks.items.filter((link) => {
        if (
          link.published &&
          link.footer_link_pages.filter((p) => p.id === pageId).length > 0
        ) {
          return true
        }
      })
      setFilteredFooterLinks(links)
    }
  }, [pageId, footerLinks])

  const handleScrollUp = () => {
    // Respect prefers-reduced-motion preference
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    })
  }
  return (
    <footer className={`footer ${styles.footer}`}>
      <div className={styles.inner}>
        {filteredFooterLinks?.length > 0 && (
          <nav className={styles.topLinks} aria-label={"Footer Links"}>
            <ul>
              {filteredFooterLinks.map((navItem) => (
                <li key={navItem.id}>
                  <Link href={navItem.url} prefetch={false}>
                    <a>{navItem.title}</a>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        )}

        {locations?.length > 0 && (
          <div className={styles.locationsWrapper} aria-label={"Standorte"}>
            <span className={styles.footerHeader}>Unsere Standorte</span>

            <div className={styles.locations} aria-label={"Standorte"}>
              {locations.map((loc, i) => (
                <div key={i} className={styles.location}>
                  <strong>{loc.title}</strong>
                  <span
                    dangerouslySetInnerHTML={{ __html: nl2br(loc.address) }}
                  ></span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className={styles.contactLinks}>
          <nav className={styles.social} aria-label={"Socialmedia Links"}>
            {socialMediaLinks?.map((sml, i) => {
              if (!sml.plattform?.value || !sml.url || !sml.label) return null

              const SMLogo = dynamic(() =>
                import(`../../components/icon/${sml.plattform.value}`)
              )

              return (
                <Link key={i} href={sml.url}>
                  <a
                    aria-label={sml.label}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                  >
                    <SMLogo />
                  </a>
                </Link>
              )
            })}
          </nav>

          <div className={styles.contact}>
            {/* <LinkButton
              className={cn("button--inverted", styles.contactButton)}
              data={{ link_url: "/kontakt", link_text: "Kontakt" }}
            />*/}
            <LinkButton
              className={cn("button--inverted", styles.contactButton)}
              data={{
                link_url: "mailto:contact@disphere.com",
                link_text: "E-Mail schreiben",
              }}
              icon={<Send />}
            />
            {/*<LinkButton*/}
            {/*  className={cn("button--inverted", styles.contactButton)}*/}
            {/*  data={{ link_url: "tel:+498938832400", link_text: "Anrufen" }}*/}
            {/*  icon={<Phone />}*/}
            {/*/>*/}
          </div>
        </div>

        {company?.mission && (
          <div className={styles.mission} aria-label={"Mission"}>
            <div dangerouslySetInnerHTML={{ __html: company.mission }}></div>
          </div>
        )}
      </div>
      {/* <div className="flex justify-center mt-24">
        <button onClick={handleScrollUp} className={cn("button", styles.btt)}>
          <span className={styles.buttonText}>
            Nach oben
            <ArrowUpIcon />
          </span>
        </button>
      </div>*/}
      <nav className={styles.legal} aria-label={"Weitere Links"}>
        <div className={styles.legalInner}>
          <Logo className={styles.logo} />

          <div className={styles.legalLinks}>
            {footerNav?.items.map((navItem) => (
              <Link key={navItem.id} href={navItem.url}>
                <a>{navItem.title}</a>
              </Link>
            ))}
            <a
              tabIndex={0}
              style={{ cursor: "pointer" }}
              onClick={() => {
                window?.Cookiebot?.show()
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  window?.Cookiebot?.show()
                }
              }}
            >
              Cookie-Einstellungen
            </a>
          </div>
        </div>
      </nav>
    </footer>
  )
}

export default Footer
